import "./MainMenuIcons.scss";
import type Menu from "../model/Menu";

export function menuIconClass(menuItem: Menu): string {
  return "icon-" + menuItem.key.replaceAll("_", "-");
}
